import FuturePlans from "../components/FuturePlans"
import A from "../components/A"
import FacilityHighlights from "../components/FacilityHighlights";
import OrganizationChart from "../components/OrganisationChart";
import Seperator from "../components/Seperator"
import DirectorMessage from "../components/DirectorMessage";
import CompanyGrowthFlow from "../components/CompanyGrowthFlow";

export default function AboutUs() {
  return (
    <>
    <A/>
    <CompanyGrowthFlow/>
    <FacilityHighlights/>
    <OrganizationChart/>
    <FuturePlans/>
    <DirectorMessage/>
    <Seperator/>
    </>
  );
}